var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 30C10.425 30 9.71875 29.7062 9.13125 29.1187C8.54375 28.5312 8.25 27.825 8.25 27H14.25C14.25 27.825 13.9562 28.5312 13.3687 29.1187C12.7812 29.7062 12.075 30 11.25 30ZM5.25 25.5V22.5H17.25V25.5H5.25ZM5.625 21C3.9 19.975 2.53125 18.6 1.51875 16.875C0.50625 15.15 0 13.275 0 11.25C0 8.125 1.09375 5.46875 3.28125 3.28125C5.46875 1.09375 8.125 0 11.25 0C14.375 0 17.0312 1.09375 19.2188 3.28125C21.4062 5.46875 22.5 8.125 22.5 11.25C22.5 13.275 21.9938 15.15 20.9813 16.875C19.9688 18.6 18.6 19.975 16.875 21H5.625ZM6.525 18H15.975C17.1 17.2 17.9688 16.2125 18.5812 15.0375C19.1937 13.8625 19.5 12.6 19.5 11.25C19.5 8.95 18.7 7 17.1 5.4C15.5 3.8 13.55 3 11.25 3C8.95 3 7 3.8 5.4 5.4C3.8 7 3 8.95 3 11.25C3 12.6 3.30625 13.8625 3.91875 15.0375C4.53125 16.2125 5.4 17.2 6.525 18Z",
    fill: "#FF5722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon (3).101884d865d5c2c7558f769753221536.svg";
export { ForwardRef as ReactComponent };